import { createAction } from "@reduxjs/toolkit";
import type { UpdateTeacherSettingsBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export interface UpdateTeacherSettingsParams {
  teacherId: string;
  body: UpdateTeacherSettingsBody;
}

export const updateTeacherSettings = createApiThunk<string, UpdateTeacherSettingsParams>(
  "admin/teachers/updateSettings",
  async ({ teacherId, body }, { extra: { adminRepository } }) => {
    await adminRepository!.updateTeacherSettings(teacherId, body);
    return teacherId;
  },
);

export const resetUpdateTeacherSettings = createAction("admin/teachers/resetUpdateSettings");
